<!--
@component
@deprecated REPTILE-1303
-->
<script lang="ts">
    import { untrack } from 'svelte';
    import type { DresonRuleResolvedEvent, Page } from '@shared/types/Tilelist.ts';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { appendHeurekaFragment, clean, pagedUrl } from './Utils.browser.ts';

    /**
 *
 *
 *
 */

    const { initialSession }: { initialSession: TileListInitialSession } = $props();
    const wiring = injectWiring();

    function checkpointData(rule: string, page: Page, tsLink?: DresonRuleResolvedEvent['tsLink']) {
        return { rule, page: { ...page }, tsLink, historic: true };
    }

    function urlFor(event: DresonRuleResolvedEvent): string {
        const url = event.redirect ?? pagedUrl(clean(event.page), location.pathname, location.search);
        return event.redirect && wiring.onex.isToggleActive('DA_KEEP_HEUREKA_SHEET_FRAGMENT')
            ? appendHeurekaFragment(url)
            : url;
    }

    function handleResolved(event: DresonRuleResolvedEvent): void {
        const url = urlFor(event);
        wiring.trackingService?.trackUrl(event.redirect ?? url);
        if (!event.historic) {
            wiring.eventsOutgoing?.legacyHistory.push({
                topic: 'ftfind.dresonRule.resolve',
                data: checkpointData(event.rule, event.page, event.tsLink),
                url,
            });
        }
    }

    function subscribe() {
        wiring.eventsOutgoing?.legacyHistory.merge({
            topic: 'ftfind.dresonRule.resolve',
            data: checkpointData(initialSession.page.context.rule, initialSession.page.page ?? {}, {}),
        });
        return wiring.eventsIncoming?.onPageResolved(handleResolved);
    }

    $effect(() => {
        const eventsIncoming = wiring.eventsIncoming;
        const eventsOutgoing = wiring.eventsOutgoing;
        if (!eventsIncoming || !eventsOutgoing) return;
        return untrack(subscribe);
    });
</script>
